export default __webpack_public_path__ + "static/112-min-min-943b3f2e27c1db5a0d82171924d51a25.jpg";